import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { useIsDarkmode } from '../hooks/useIsDarkmode';
import '../Styles/_markdown.scss';

type Props = {
    children: string;
};

export const MarkdownViewer: FC<Props> = ({ children }) => {
    const isDarkmode = useIsDarkmode();

    return (
        <ReactMarkdown skipHtml className={`markdown-body${isDarkmode ? ' darkMode' : ''}`} remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw as any]}>
            {children}
        </ReactMarkdown>
    );
};
